<template>
    <b-overlay :show="tableLoading" rounded="sm">
        <b-card class="inner-block progress-status">
            <b-card-header>
                <b-row class="mt-2">
                    <b-col cols="12" class="d-flex">
                        <b-input id="search-input" type="text" :placeholder="$translate('search')" v-model="query"></b-input>
                        <slot></slot>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-card-body>
                <b-col class="page-block">
                    <strong>
                        {{ $translate("page") }}: {{ pagination.page }}
                        {{ $translate("of") }} {{ pageCount }} {{ $translate("total") }}:
                        {{ pagination.total }}
                    </strong>
                </b-col>
                <b-col class="overflow-auto w-100 mt-4">
                    <div class="responsive-table">
                        <b-table class="table table-striped" :fields="fields" :items="items" :per-page="itemsPerPage"
                            :current-page="currentPage" :filter="filters" show-empty>
                            <template #cell(id)="{ item }">
                                <b-button :id="'view-rpa-task-btn'+item.id" class="test-view-rpa-task-btn" v-if="hasPermissionView" @click="$emit('show-item', item.id)"
                                    variant="pink-button">
                                    <img src="@/assets/images/icon/view.svg" />
                                </b-button>
                            </template>
                        </b-table>
                    </div>
                </b-col>
            </b-card-body>
            <b-row>
                <b-col>
                    <b-pagination class="justify-content-center mt-4" v-model="pagination.page"
                        :total-rows="pagination.total" :per-page="pagination.pageSize" aria-controls="customerTable"
                        :prev-text="$translate('previous')" :next-text="$translate('next')" pills
                        align="center"></b-pagination>

                </b-col>
            </b-row>
        </b-card>
    </b-overlay>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import dateTimeMixins from "@/mixins/dateTimeMixins";

export default {
    name: 'RpaTasks-ListItems',
    mixins: [popupMixins, permissionsMixins, dateTimeMixins],
    props: {
        //type, // not used
        /**
         * The title of the table
         */
        title: String,
    },
    components: {},

    data() {
        return {
            filters: {
            },
            query: '',
            itemsPerPage: 15,
            tableLoading: false,
            currentPage: 1,
            rowsLength: this.rows,
        }
    },

    mounted() {
        this.doSearch(true)
    },


    watch: {},

    computed: {
        fields() {
            const { displayLocalDate } = this;
            return [
                { key: 'id', label: this.$translate('actions') },
                {
                    key: 'vendor',
                    label: this.$translate('vendor'),
                    formatter: (value) => value?.name
                },
                {
                    key: 'order_type',
                    label: this.$translate('activity_type'),
                    formatter: (value) => value?.name
                },
                {
                    key: 'default_driver',
                    label: `${this.$translate('default')} ${this.$translate('officer')}`,
                    formatter: (value) => value ? `${value.first_name} ${value.last_name}` : ''
                },
                { key: 'original_sender', label: this.$translate('original_sender') },
                {
                    key: 'bill_payment_to',
                    label: this.$translate('bill_payment_to'),
                    formatter: (value) => value?.username
                },
                { key: 'no_of_days_bill_due', label: this.$translate('no_of_days_bill_due') },
                { 
                    key: 'notify_users', 
                    label: this.$translate('bill_notification_list'),
                    formatter: (value) => value ? value.map(x => `${x.first_name} ${x.last_name}`).join(", ") : '',
                    tdClass: 'order-table-description',
                },
                { key: 'type', label: this.$translate('type') },
                {
                    key: "last_checked_at",
                    label: this.$translate("last_checked_at"),
                    formatter: (value) => displayLocalDate(value),
                },
                { key: 'is_active', label: this.$translate('is_active'), formatter: (value) => value ? 'Yes' : 'No' },
            ]
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize);
        },
        pagination() {
            return this.$store.state.rpaTask.pagination || { page: 1 };
        },
        items() {
            const items =
                this.$store.state.rpaTask.items

                || []
            return items
        },
        user() {
            return this.$store.state.user
        },

        rows() {
            return this.items.length
        }
    },

    methods: {
        async doSearch(isforcedReload = false) {
            try {

                let {
                    query,
                    pagination: { page },
                    filters
                } = this

                if (query != "" && query.length < 3) return;

                page = parseInt(page) || 1;

                this.tableLoading = true

                await this.$store.dispatch('rpaTask/fetchAll', {
                    query,
                    filters,
                    page,
                    isforcedReload
                })
            } catch (err) {
                console.log('rpaTask fetch Error: ', err);
                this.doToast(this.$translate('error'), err.message, 'danger')
            } finally {
                this.tableLoading = false
            }
        },
        deleteItem(id) {
            let item = this.items.find(el => el.id == id)

            const title = 'Delete Type?'
            const message = `${this.$translate('delete_note')} ${item.email}?`
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.$store
                        .dispatch('rpaTask/delete', id)
                        .then(() => {
                            this.doToast(
                                this.$translate('deleted'),
                                this.$translate('item_delete_alert'),
                                'success'
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.doToast(
                                this.$translate('error'),
                                this.$translate('unable_alert'),
                                'danger'
                            )
                        })
                }
            })
        },
    },
}
</script>
<style></style>
